import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  SelectField,
  EditButton,
  Filter,
  SelectInput,
  ChipField,
  ReferenceArrayInput,
  SelectArrayInput,
  DateField
} from "react-admin";
import { required } from "../../services/validate";
import { SUPERADMIN } from "../../constant/TypeRole";
import Actions from '../Actions'

const SosFilter = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <Filter {...props}>
      <SelectInput
        source="status"
        choices={[
          { id: 0, name: "Open" },
          { id: 1, name: "Followup" },
          { id: 2, name: "Closed" }
        ]}
      />
      <ReferenceArrayInput
        alwaysOn
        style={{ minWidth: "200px" }}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
      {/* <TextInput label="Search" source="q" alwaysOn />
        <TextInput label="Title" source="title" defaultValue="Hello, World!" /> */}
    </Filter>
  );
};

export const SosList = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
  return (
    <List
      {...props}
      title="sos.sos"
      bulkActions={false}
      filters={<SosFilter />}
      sort={{ field: "createdAt", order: "DESC" }}
      filterDefaultValues={filter}
      actions={<Actions />}
    >
      <Datagrid>
        <div />
        <ReferenceField source="room" reference="room" linkType={false}>
          <TextField source="name" />
        </ReferenceField>
        <SelectField
          source="status"
          optionText={<ChipField source="name" />}
          choices={[
            { id: 0, name: "Open" },
            { id: 1, name: "Followup" },
            { id: 2, name: "Closed" }
          ]}
        />
        <ReferenceField source="project" reference="project" linkType={false}>
          <ChipField source="name" />
        </ReferenceField>
        <ReferenceField source="user" reference="user" linkType={false}>
          <TextField source="mobile" />
        </ReferenceField>
        <DateField
          source="createdAt"
          locales="th-TH"
          options={{
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
          }}
        />
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/sos/SosList.js